// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__MUkcU","infoWrapper":"styles_infoWrapper__2FQX-","info":"styles_info__OfR-T","error":"styles_error__1_QQG","action":"styles_action__VZTYJ"};